import React from 'react'
import AltNav from '../components/AltNav.js';

const PeaceOfHeart = () => {
    return (
        <div>
            <AltNav />
            <div className='work-alt-header-bg'></div>
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />

            <div className='work-page-main'>
                <div className='blue-glow projects-header'>
                    <div className='gb-inner gb-inner-img' style={{ backgroundImage: `url('portfolio-images/peace-of-heart.jpg')` }}>
                        <div class="glow-wrapper">
                            <span class="glow-text">THERAPIST WEBSITE</span>
                            <span class="stroke-text">THERAPIST WEBSITE</span>
                        </div>

                        <h2>PEACE OF HEART THERAPY</h2>
                    </div>
                </div>


                <br />
                <br />

                <div className='overview'>
                    <div className='ov1'>
                        <h2>Overview</h2>

                        <p>Simple Therapist Website Build + logo and business card design.</p>

                        <ul>
                            <li>Built and designed website for Peace of Heart Therapy</li>
                            <li>Built Website using Wix</li>
                            <li>Simple Informational Site with email form</li>
                            <li>Designed their logo as well</li>
                            <li>Designed other promotional materials such as letterheads, pens, and their business card</li>

                        </ul>
                        <a href='https://www.peaceofheart-therapy.com/' target='_blank'>
                            <button className='glow-box-btn ovbtn'>
                                View Site
                            </button>
                        </a>

                    </div>
                    <div className='ov2'>
                        <div className='pink-glow'>
                            <div className='pg-inner'>
                                <img src='portfolio-images/poh1.jpg' alt='Eventure Desktop View' />
                            </div>

                        </div>

                    </div>
                </div>
                <br />
                <br />




                <div className='pink-glow'>
                    <div className='pg-inner project-summary'>
                        <h3 className='summary'>Summary</h3>
                        <p>At Peace of Heart Therapy, I worked as a web and design contractor, supporting the clinic’s digital presence through website updates, visual branding, and user experience improvements. I maintained and enhanced their WordPress site to ensure accessibility, mobile responsiveness, and a warm, calming aesthetic that aligned with the practice’s mission. My role also included designing promotional materials and streamlining content updates to help therapists and administrators communicate more effectively with clients.</p>
                    </div>
                </div>

                <br />
                <br />







            </div>
        </div>
    )
}

export default PeaceOfHeart